// noinspection JSUnusedGlobalSymbols usages in external projects

/**
 * Represents the roles an authenticated user can have.
 */
export enum UserRole {
  Admin = 1,
  RegionManager = 2,
  CompetitionManager = 3,
  ClubManager = 4,
  User = 5,
  Guest = 6,
}
